import LayoutPage from "../../Components/LayoutPage"
import Buttons from "./Components/Buttons"
import AccountsList from "./Components/AccountsList"

export default function Accounts() {
  return (
    <LayoutPage activeIndex={2} navItems={["مدیریت حساب‌ها"]} childrenClassName="flex-1 min-h-0 flex flex-col gap-5 overflow-auto">
      <Buttons/>
      <AccountsList/>
    </LayoutPage>
  )
}